<template>
  <div>
    <div id="search-banner" :class="searchContainerClass">
      <div class="main-search">
        <div class="btn-extra-search">
          <div
            :class="['btn-extra-search-circle toggle', { active: isSidebarVisible }]"
            :tooltip="this.$i18n.t('reszletes_kereses')"
            tabindex="0"
            @click="toggleFilter"
            @keypress.enter="toggleFilter"
          >
            <a :title="this.$i18n.t('reszletes_kereses')"
              ><span class="ml-2">{{ $i18n.t('reszletes_kereses') }}</span></a
            >
          </div>
        </div>
      </div>
    </div>

    <div id="filter-sidebar" :style="sidebarSlider">
      <div class="detailed-search">
        <div class="search-header">
          <h3>{{ $i18n.t('reszletes_kereses') }}</h3>
          <span class="fa fa-times" @click="toggleFilter"></span>
        </div>
        <div>
          <h4>{{ $i18n.t('entity_nev') }}</h4>
          <div id="entityName">
            <base-input v-bind="filters.entityName" @form-item-changed="onChange"></base-input>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('NATIONALITY_NAME_') }}</h4>
          <div>
            <base-datalist ref="nationality" v-bind="filters.nationality" @form-item-changed="onChange">
            </base-datalist>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('ENTITY_TYPE') }}</h4>
          <div>
            <choice-list ref="entityType" v-bind="filters.entityType" @form-item-changed="onChange"></choice-list>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('szuletesi_hely') }}</h4>
          <div id="birthPlace">
            <base-input v-bind="filters.birthPlace" @form-item-changed="onChange"></base-input>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('cim') }}</h4>
          <div id="address">
            <base-input v-bind="filters.address" @form-item-changed="onChange"></base-input>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('iparag') }}</h4>
          <div id="industry">
            <base-input v-bind="filters.industry" @form-item-changed="onChange"></base-input>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('sanction_code') }}</h4>
          <div id="sanctionCode">
            <base-datalist ref="sanctionCode" v-bind="filters.sanctionCode" @form-item-changed="onChange">
            </base-datalist>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('szankciot_hozo') }}</h4>
          <div id="sanctionOwner">
            <base-datalist ref="sanctionOwner" v-bind="filters.sanctionOwner" @form-item-changed="onChange">
            </base-datalist>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('szankcio_hataly_ala_kerulesenek_datuma') }}</h4>
          <div id="sanctionDate">
            <div>
              <date_interval v-bind="filters.sanctionDateStart" @form-item-changed="onChange"></date_interval>
            </div>
          </div>
        </div>
        <div>
          <h4 class="p-status">{{ $i18n.t('palyazat_statusza') }}</h4>
          <div class="palyazat-statusza">
            <div
              v-for="status in filters.status.list"
              :id="status.id"
              :key="status.key"
              :class="['choice', { active: isStatusActive(status.key) }]"
              tabindex="0"
              @click="setStatus(status.key)"
              @keypress.enter="setStatus(status.key)"
            >
              <span :class="status.icon"></span>
              <span class="label">{{ status.value }}</span>
            </div>
          </div>
        </div>

        <div><br /></div>
      </div>
      <div :style="sidebarSlider" class="btn-container">
        <a
          :href="`/ext-sanction/index${filter}`"
          class="search-button"
          @click="setParams"
          @keypress.enter="setParams"
          tabindex="0"
          >{{ $i18n.t('alkalmaz') }}</a
        >
        <span class="search-clear" @click="onClearFilter" @keypress.enter="onClearFilter" tabindex="0">{{
          $i18n.t('szuro_torlese')
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import RadiobuttonList from '../form/controls/ChoiceList'
import BaseDatalist from '../form/controls/BaseDatalist'
import BaseInput from '../form/controls/BaseInput'
import NumberInput from '../form/controls/NumberInputOld'
import EventBus from '../../utils/event-bus'
import { get, forEach, isEmpty, equals, isNil } from 'lodash'
import DateTime from '../form/controls/DateTime'
import date_interval from '../form/controls/DateTimeFilter'
import ChoiceList from '../form/controls/ChoiceList'
import DateIntervalControl from '../list/search/fields/DateControl'
import Checklist from '../form/controls/Checklist'

export default {
  name: 'TenderFilter',
  components: {
    Checklist,
    DateIntervalControl,
    NumberInput,
    BaseInput,
    RadiobuttonList,
    BaseDatalist,
    ChoiceList,
    date_interval,
  },
  data() {
    return {
      isLoading: false,
      isSidebarVisible: false,
      recordsCount: null,
      processId: '6267cd9b09599f00118c1e72',
      filters: {
        searchTitle: '',
        entityName: {
          name: 'entityName',
          title: this.$i18n.t('ENTITY_NAME'),
          placeholder: this.$i18n.t('ENTITY_NAME'),
          data: 'NAME_AND_TARNSLATE',
          filterFormat: 'text',
          type: 'text',
          multiple: false,
          visible: true,
          value: '',
        },
        nationality: {
          name: 'nationality',
          title: this.$i18n.t('NATIONALITY_NAME_'),
          placeholder: this.$i18n.t('NATIONALITY_NAME_'),
          data: 'ID_NATIONALITY',
          filterFormat: 'dropdownlist',
          type: 'dropdownlist',
          multiple: true,
          visible: true,
          searchable: true,
          showSearchBar: true,
          value: [],
          list: '/api/Dynforms/pathfinder?type=query&value=626fa4fe461d4300219f5e19',
        },
        entityType: {
          name: 'entityType',
          title: this.$i18n.t('ENTITY_TYPE'),
          placeholder: this.$i18n.t('ENTITY_TYPE'),
          data: 'ID_ENTITY_TYPE',
          filterFormat: 'checkboxlist',
          type: 'checkboxlist',
          multiple: true,
          visible: true,
          searchable: true,
          localizeData: true,
          showSearchBar: false,
          value: [],
          list: '/api/Dynforms/pathfinder?type=query&value=626a559e037a4d001111c1bc',
        },
        birthPlace: {
          name: 'birthPlace',
          title: this.$i18n.t('szuletesi_hely'),
          placeholder: this.$i18n.t('szuletesi_hely'),
          data: 'ENTITY_BIRTH_PLACE',
          filterFormat: 'text',
          type: 'text',
          multiple: false,
          visible: true,
          value: '',
        },
        address: {
          name: 'address',
          title: this.$i18n.t('cim'),
          placeholder: this.$i18n.t('cim'),
          data: 'ADDRESS',
          filterFormat: 'text',
          type: 'text',
          multiple: false,
          visible: true,
          value: '',
        },
        industry: {
          name: 'industry',
          title: this.$i18n.t('iparag'),
          placeholder: this.$i18n.t('iparag'),
          data: 'INDUSTRY',
          filterFormat: 'text',
          type: 'text',
          multiple: false,
          visible: true,
          value: '',
        },
        sanctionCode: {
          name: 'sanctionCode',
          title: this.$i18n.t('SANCTION_CODE'),
          placeholder: this.$i18n.t('SANCTION_CODE'),
          data: 'ID_SANCTION',
          filterFormat: 'dropdownlist',
          type: 'dropdownlist',
          multiple: true,
          visible: true,
          searchable: true,
          showSearchBar: true,
          value: [],
          list: '/api/Dynforms/pathfinder?type=query&value=6283840fc7bfd4001f2c73cc',
        },
        sanctionOwner: {
          name: 'sanctionOwner',
          title: this.$i18n.t('SANCTION_OWNER'),
          placeholder: this.$i18n.t('SANCTION_OWNER'),
          data: 'ID_SANCTION_OWNER',
          filterFormat: 'dropdownlist',
          type: 'dropdownlist',
          multiple: true,
          visible: true,
          searchable: true,
          localizeData: true,
          showSearchBar: false,
          value: [],
          list: '/api/Dynforms/pathfinder?type=query&value=62836669dfb7eb001fa0411e',
        },
        sanctionDateStart: {
          name: 'sanctionDateStart',
          title: this.$i18n.t('hataly'),
          placeholder: this.$i18n.t('hataly'),
          data: 'START_DATE',
          filterFormat: 'date',
          type: 'date',
          visible: true,
          multiple: true,
          value: ['', ''],
        },
        status: {
          name: 'status',
          title: this.$i18n.t('palyazat_statusza'),
          data: 'SANCTION_STATUS_NAME',
          filterFormat: 'checkboxlist',
          type: 'checkboxlist',
          multiple: true,
          visible: true,
          value: [],
          list: [
            {
              key: 'hatalyos',
              value: this.$i18n.t('hatalyos'),
              icon: 'fa fa-check',
              id: 'active',
            },
            {
              key: 'bejelentes',
              value: this.$i18n.t('bejelentes'),
              icon: 'fa fa-clock-o',
              id: 'pending',
            },
            {
              key: 'nemAz',
              value: this.$i18n.t('nemAz'),
              icon: 'fa fa-times',
              id: 'closed',
            },
          ],
        },
      },
    }
  },
  computed: {
    sidebarSlider() {
      return this.isSidebarVisible ? 'left: 0' : 'left: -500px'
    },
    filter() {
      let search = ''
      forEach(this.filters, (param) => {
        if (param.name === 'sanctionDateStart' && param.value[0] === '' && param.value[1] === '') {
        } else {
          if (!isNil(param.value) && param.value.toString().length) {
            if (search.length) {
              search += '&'
            } else {
              search += '?'
            }
            if (Array.isArray(param.value)) {
              forEach(param.value, (value, idx) => {
                if (idx) {
                  search += '&'
                }
                if (param.multiple || param.type === 'radiobuttonlist') {
                  search += `${this.processId}[${param.data}][${idx}]=${value}`
                } else {
                  search += `${this.processId}[${param.data}]=${value}`
                }
              })
            } else {
              search += `${this.processId}[${param.data}]=${param.value}`
            }
          }
        }
      })
      return encodeURI(search.replace('+', '%2B'))
    },
    searchContainerClass() {
      return window.location.pathname === '/ext-sanction/index' ? 'search-bar-top' : 'search-container'
    },
    searchTitle() {
      return this.filters.usearch.value && this.filters.usearch.value.length
        ? this.filters.usearch.value
        : this.$i18n.t('szures_eredmenye')
    },
  },
  methods: {
    toggleFilter() {
      this.isSidebarVisible = !this.isSidebarVisible
    },
    onChange(evt) {
      if (get(this.filters, [evt.name]).hasOwnProperty('value')) {
        const oldVal = this.filters[evt.name].value
        const newVal = evt.value
        if (!equals(oldVal, newVal)) {
          this.filters[evt.name].value = evt.value
          if (evt.name === 'order') {
            this.onEnter()
          }
        }
      }
      /*  if (evt.name === 'locationType') {
                  if (evt.value[0] === 'city') {
                    this.filters.location.placeholder = this.$i18n.t('telepules_neve_vagy_iranyitoszama')
                  } else {
                    this.filters.location.placeholder = this.$i18n.t('regio_neve')
                  }
                }*/
    },
    onClearFilter() {
      forEach(this.filters, (param) => {
        if (!isEmpty(param.value)) {
          if (Array.isArray(param.value)) {
            param.value = []
          } else {
            param.value = ''
          }
          this.filters.sanctionDateStart.value = ['', '']
        }
      })
      this.filters.status.value = []
      // this.filters.locationType.value = ['city']
      //this.filters.location.placeholder = this.$i18n.t('telepules_neve_vagy_iranyitoszama')
      this.filters.order.value = ['name_asc']
      this.setParams()
    },
    setStatus(status) {
      const val = this.filters.status.value
      if (val.includes(status)) {
        val.splice(val.indexOf(status), 1)
      } else {
        val.push(status)
      }
    },
    onEnter() {
      this.setParams()
      window.location.href = `/ext-sanction/index${this.filter}`
    },
    setParams() {
      this.isLoading = true
      // if (this.filters.locationType.value[0] === 'city') {
      //   this.filters.regions.value = []
      // } else {
      //   this.filters.location.value = ''
      // }
      // this.filters.searchTitle = this.searchTitle
      window.localStorage.setItem('filters', JSON.stringify(this.filters))
    },
    setRecordsCount(evt) {
      this.recordsCount = evt.newVal
    },
    isStatusActive(status) {
      return this.filters.status.value.includes(status)
    },
    getStoredFilter() {
      if (!isEmpty(this.$route.query) && window.localStorage && !isEmpty(window.localStorage.filters)) {
        this.filters = JSON.parse(window.localStorage.getItem('filters'))
      }
    },
  },
  beforeCreate() {
    EventBus.$on('refresh-recordsCount', (evt) => this.setRecordsCount(evt))
  },
  beforeDestroy() {
    EventBus.$off('refresh-recordsCount', (evt) => this.setRecordsCount(evt))
  },
  mounted() {
    this.getStoredFilter()
  },
}
</script>

<style scoped>
.search-button {
  border: 1px solid #0a65ff;
  color: #fff;
}
.search-button:hover,
.search-button:active {
  background-color: white;
  border: 1px solid #0a65ff;
  color: #0a65ff !important;
}
</style>
